import { useTranslation } from 'react-i18next';

import { Footer } from 'modules/footer';
import { Header } from 'modules/header';

import { ContactsCard } from './components/contacts-card';
import { SubmissionForm } from './components/submission-form';

export const ContactUs = () => {
  const { t } = useTranslation();

  const content = {
    title: t('contact_us_page.title'),
    email: t('contact.email'),
    phone: t('contact.phone'),
    address: t('contact.address'),
    faqTitle: t('contact_us_page.faqTitle'),
    faqButton: t('contact_us_page.faqButton'),
    formTitle: t('contact_us_page.formTitle'),
    formName: t('contact_us_page.formName'),
    formEmail: t('contact_us_page.formEmail'),
    formMessage: t('contact_us_page.formMessage'),
    formSubmit: t('contact_us_page.formSubmit'),
    errorRequired: t('contact_us_page.errorRequired'),
    errorEmail: t('contact_us_page.errorEmail'),
    errorDefault: t('contact_us_page.errorDefault'),
    successMessage: t('contact_us_page.successMessage'),
    sending_message: t('contact_us_page.sending_message'),
    support: t('contact_us_page.support')
  };
  const { title: contentTitle } = content;

  return (
    <div>
      <Header />
      <section className='mx-auto box-content max-w-[1256px] flex-col px-4 pb-8 pt-20 text-center md:px-20 md:pb-16 md:pt-36 lg:flex'>
        <h1 className='mb-6 text-2xl font-black tablet:mb-12 tablet:text-6xl'>{contentTitle}</h1>

        <div className='flex flex-col gap-6 lg:flex-row '>
          <ContactsCard />

          <SubmissionForm />
        </div>
      </section>
      <Footer backgroundColor='#F6F6F6' />
    </div>
  );
};
